<span
    (mouseenter)="onTriggerEnter()"
    (mouseleave)="onTriggerLeave()"
    [popover]="popoverUpdatePlan"
    [isOpen]="isOpen"
    triggers=""
    placement="bottom"
    container="body"
    containerClass="custom-popover"
    class="badge-update-plan"
    #p="bs-popover"
    (onShown)="popover = p"
    (onHidden)="onHidden()"
>
    {{ "popover_update_tariff_label" | translate }}
</span>

<ng-template #popoverUpdatePlan>
    <div class="content" (mouseenter)="onPopoverEnter()" (mouseleave)="onPopoverLeave()">
        <div class="title">{{ "popover_pro_tariff_header" | translate }}</div>
        <ul>
            <li>{{ "popover_pro_tariff_option1" | translate }}</li>
            <li>{{ "popover_pro_tariff_option2" | translate }}</li>
            <li>{{ "popover_pro_tariff_option3" | translate }}</li>
            <li>{{ "popover_pro_tariff_option4" | translate }}</li>
            <li>{{ "popover_pro_tariff_option5" | translate }}</li>
            <li>{{ "popover_pro_tariff_option6" | translate }}</li>
        </ul>
        <a class="upgrade-link btn btn-paid" href="/landing-pages/plans/">
            {{ "popover_pro_tariff_link" | translate }}
            <small class="sp-icon icon-outgoing">&nbsp;</small>
        </a>
    </div>
</ng-template>
